import Arrow from './arrow';
import BgVideo from './bg-video/index';
import CalenderModal from './modals/calender/index';
import Counter from './counter/index';
import FlashMessage from './flash-messages/index';
import Hero from './hero/index';
import Innovation from './innovation/index';
import Modal from './modals/index';
import PresskitFlashMessage from './flash-messages/presskit/index';
import SihhFlashMessage from './flash-messages/sihh/index';
import PhaseWrapper from './phase-wrapper/index';
import Tabs from './tabs/tabs/index';
import TabButton from './tabs/tab-button/index';
import TabContent from './tabs/tab-content/index';
import VideoModal from './modals/video/index';

export default {
  XArrow: Arrow,
  XBgVideo: BgVideo,
  XCalenderModal: CalenderModal,
  XCounter: Counter,
  XFlashMessage: FlashMessage,
  XHero: Hero,
  XInnovation: Innovation,
  XModal: Modal,
  XPresskitFlashMessage: PresskitFlashMessage,
  XSihhFlashMessage: SihhFlashMessage,
  XPhaseWrapper: PhaseWrapper,
  XTabs: Tabs,
  XTabButton: TabButton,
  XTabContent: TabContent,
  XVideoModal: VideoModal,
};



// WEBPACK FOOTER //
// ./src/js/components/index.js